import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .river-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    .block-header {
      grid-column: 2 / 8;
      grid-row: 2;
      height: fit-content;
      margin-bottom: var(--between-row-padding);
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      height: fit-content;
      margin-bottom: var(--between-row-padding);
    }

    .description p {
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    /* Card list: single column on mobile, nested 12-col grid at 600px. */
    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: var(--between-row-padding-lg) var(--between-column-padding);
    }

    /* Card: image above text on mobile, equal halves from 600px. */
    .image-wrapper {
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: calc(16rem / var(--default-rem-px-count))
        var(--between-column-padding);
    }

    .image-wrapper img {
      display: block;
      width: 100%;
    }

    /* Card titles are .type-label labels (14 medium -> 16 at 600px). */

    .image-info p {
      padding: calc(16rem / var(--default-rem-px-count)) 0;
    }

    @media (min-width: 600px) {
      .river-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      /* Top-row texts share a first baseline. */
      .block-header {
        grid-column: 2 / 8;
        align-self: baseline;
        margin-bottom: var(--between-row-padding-lg);
      }

      .description {
        grid-column: 8 / 14;
        grid-row: 2;
        align-self: baseline;
        margin-bottom: var(--between-row-padding-lg);
      }

      .images {
        grid-column: 2 / 14;
        grid-row: 3;
        grid-template-columns: repeat(12, minmax(0, 1fr));
      }

      .image-wrapper {
        grid-column: span 6;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0 var(--between-column-padding);
      }
    }

    @media (min-width: 1024px) {
      .river-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .block-header {
        grid-column: 2 / 5;
        margin-bottom: 0;
      }

      .description {
        grid-column: 5 / 8;
        margin-bottom: 0;
      }

      .images {
        grid-column: 9 / 13;
        grid-row: 2;
      }

      .image-wrapper {
        grid-column: 1 / -1;
      }
    }
  `,
];
